import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportAwardedFinalEstimateView,
    FinalEstimatesClient,
    GetAwardedFinalEstimatesMetricsValuesResultType,
    GetAwardedFinalEstimatesValuesParameters,
    GetExternalAwardedFinalEstimatesValuesResultType,
    GetFinalEstimatesColumnChartValuesResultType,
    GetFinalEstimatesLineChartValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class FinalEstimatesService extends CustomReportServiceBase<
    FinalEstimatesClient,
    CustomReportAwardedFinalEstimateView
> {
    constructor(protected override client: FinalEstimatesClient) {
        super(client);
    }

    async getAwardedFinalEstimatesMetricsValues(
        parameters: GetAwardedFinalEstimatesValuesParameters
    ): Promise<GetAwardedFinalEstimatesMetricsValuesResultType> {
        return await lastValueFrom(this.client.finalEstimatesGetAwardedFinalEstimatesMetricsValues(parameters));
    }

    async getAwardedFinalEstimatesBoxesValues(
        parameters: GetAwardedFinalEstimatesValuesParameters
    ): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.finalEstimatesGetAwardedFinalEstimatesBoxesValues(parameters));
    }

    async getAwardedFinalEstimatesValues(
        parameters: GetAwardedFinalEstimatesValuesParameters
    ): Promise<GetExternalAwardedFinalEstimatesValuesResultType[]> {
        return await lastValueFrom(this.client.finalEstimatesGetAwardedFinalEstimatesValues(parameters));
    }

    async getFinalEstimatesLineChartValues(
        parameters: GetAwardedFinalEstimatesValuesParameters
    ): Promise<GetFinalEstimatesLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.finalEstimatesGetFinalEstimatesLineChartValues(parameters));
    }

    async getFinalEstimatesColumnChartValues(
        parameters: GetAwardedFinalEstimatesValuesParameters
    ): Promise<GetFinalEstimatesColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.finalEstimatesGetFinalEstimatesColumnChartValues(parameters));
    }

    override async saveCustomReport(
        body: CustomReportAwardedFinalEstimateView
    ): Promise<CustomReportAwardedFinalEstimateView> {
        if (body.isPublic) return await lastValueFrom(this.client.finalEstimatesSaveCatalogReport(body));
        else return await lastValueFrom(this.client.finalEstimatesSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportAwardedFinalEstimateView> {
        return await lastValueFrom(this.client.finalEstimatesGetCustomReport(id));
    }

    override async shareReport(body: CustomReportAwardedFinalEstimateView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.finalEstimatesCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportAwardedFinalEstimateView> {
        return await lastValueFrom(this.client.finalEstimatesGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.finalEstimatesResultAvailableColumns(organizationIds));
    }
}
